import Network from '@/common/lib/Network';
import Store from '@/config/store';

export default {
  /**
   * Récupère la liste des factures en fonction des paramètres
   * de recherche passé dan <query_data>
   *
   * @param   {Object}  query_data  Objet de recherche des factures
   *
   * @return  {Promise}
   */
  getInvoiceList(query_data) {
  
    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      ...query_data
    };

    return Network.execute('GET', 'CWEBS0043A', data);
  },
  getInvoiceDetailsList(pnfact) {
      
    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      pnfact
    };

    return Network.execute('GET', 'CWEBS0044A', data);
  },
  /**
   * Génère un bon de livraison sur le serveur 
   * et retourne le chemin dans une Promise
   *
   * @param   {integer}  pnbl  Numéro du bon de livraison
   *
   * @return  {Promise}
   */
  getDownloadBL(pnbl) {
       
    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnbl
    };

    return Network.execute('GET', 'CWEBS0060A', data, {}, {
      'Content-Type': 'application/json',
      'Accept': 'application/pdf'
    }, 'arraybuffer');
  },
  /**
   * Génère une facture sur le serveur 
   * et retourne le chemin dans une Promise
   *
   * @param   {integer}  pnfact  Numéro de la facture
   *
   * @return  {Promise}
   */
  getDownloadInvoice(pnfact) {
      
    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnfact
    };

    return Network.execute('GET', 'CWEBS0061A', data, {}, {
      'Content-Type': 'application/json',
      'Accept': 'application/pdf'
    }, 'arraybuffer');
  },
}